import { Injectable } from "@angular/core";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { AuthService } from "../../base-module/base-service/auth.service";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class ClienteProdutoService {

    constructor(private authService: AuthService,
        private _http: HttpClient,
        public utilitesService: UtilitesService) {
    }    

    /**
     * Lista
     * @param id ID
     */
    getAll(params: any): Observable<any> {

        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if(paramHttp != null && paramHttp != ""){
            env = "?"+paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "dashboard-produto-cliente"+env, { headers: this.authService.getAuthHeaders() });
    }

}